import { Link } from 'react-router-dom';
import { cn } from '../../lib/cn';
import { useConfirmableLinkClick } from '../../lib/useConfirmableLinkClick';

interface StatCardProps {
  value: string;
  label: string;
  variant?: 'gold' | 'plain';
  link?: string;
  confirmLeave?: boolean;
}

export default function StatCard({ value, label, variant = 'plain', link, confirmLeave }: StatCardProps) {
  const isGold = variant === 'gold';
  const onClick = useConfirmableLinkClick(link, confirmLeave);
  const content = isGold ? (
    <>
      <div className="shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-full bg-paper shadow-[0_2px_8px_rgba(0,0,0,0.18)] flex items-center justify-center overflow-hidden p-1">
        <img src="/gujarat-tourism-logo.webp" alt="Gujarat Tourism" width={112} height={112} className="w-full h-full object-contain" />
      </div>
      <div className="min-w-0">
        <div className="font-serif text-[22px] md:text-[26px] text-gold-ink leading-tight">{value}</div>
        <div className="text-[13.5px] font-semibold text-gold-ink-soft mt-0.5">{label}</div>
      </div>
    </>
  ) : (
    <>
      <div className="font-serif text-[26px] md:text-[30px] text-ink">{value}</div>
      <div className="text-[13.5px] text-muted mt-1.5">{label}</div>
    </>
  );

  const classes = cn(
    isGold
      ? 'hs-gold rounded-lg p-6 h-full flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 text-center sm:text-left'
      : 'hs-card bg-paper border border-hairline rounded-lg text-center p-6 h-full flex flex-col items-center justify-center',
    link && 'transition-opacity hover:opacity-90',
  );

  if (link) {
    const isExternal = /^https?:\/\//.test(link);
    return isExternal ? (
      <a href={link} target="_blank" rel="noopener noreferrer" className={classes} onClick={onClick}>
        {content}
      </a>
    ) : (
      <Link to={link} className={classes} onClick={onClick}>
        {content}
      </Link>
    );
  }

  return <div className={classes}>{content}</div>;
}
